const QUEBON_API = 'https://api.quebon.tv'

export interface QuebonNewsItem {
  noticeId: number
  title: string
  content?: string
}

export interface QuebonNewsResponse {
  list: QuebonNewsItem[]
}

export async function fetchNewsList(
  page = 0,
  count = 3,
): Promise<QuebonNewsResponse> {
  const url =
    `${QUEBON_API}/notification/v2/notices` +
    `?page=${page}&count=${count}&board=news&showContent=true`
  const res = await fetch(url, { credentials: 'omit' })
  if (!res.ok) {
    throw new Error(`Failed to load news: ${res.status}`)
  }
  return res.json()
}

/** Extract source/title from "[조선일보] 어쩌고 저쩌고" pattern. */
export function parseNewsTitle(raw: string): { source: string; title: string } {
  const match = raw.match(/^\[([^\]]+)\]\s*(.+)$/)
  if (match) {
    return { source: match[1], title: match[2].trim() }
  }
  return { source: '', title: raw }
}

/** Strip HTML tags + collapse whitespace for excerpt. */
export function stripHtml(html: string): string {
  if (typeof document === 'undefined') {
    return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
  }
  const tmp = document.createElement('div')
  tmp.innerHTML = html
  return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim()
}
